







































import { Prop, Component, Vue, Inject } from 'vue-property-decorator'
import { cloneDeep, isEqual } from 'lodash'
import { ReferralNode } from '@/api/model/referral-node'
import { ReferralNodeAPI } from '@/api/backend-client'

@Component
export default class CompanySettingsSourcesEditIncoming extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    @Prop({ required: true }) readonly referralNodeId!: string
    referralNode: ReferralNode = null
    editingNode: ReferralNode = null
    loading: boolean = false
    saving: boolean = false

    async created(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.referralNode = await ReferralNodeAPI.get(this.referralNodeId)
        this.editingNode = cloneDeep(this.referralNode)
        this.loading = false
    }

    async save(): Promise<void> {
        this.saving = true
        this.referralNode = await ReferralNodeAPI.update(this.referralNodeId, this.editingNode)
        this.editingNode = cloneDeep(this.referralNode)
        await this.reloadCompany()
        this.saving = false
        await this.$router.push({ name: 'company_settings_sources_list' })
    }

    async cancel(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_sources_list',
        })
    }

    get hasChanges(): boolean {
        return isEqual(this.referralNode, this.editingNode) === false
    }
}
